import { render } from "./EstacaoDashboard.vue?vue&type=template&id=53aaf333"
import script from "./EstacaoDashboard.vue?vue&type=script&lang=js"
export * from "./EstacaoDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__